// Lista de moedas para escolher (Finanças e a moeda de cada valor nas abas, 0.69 Parte B1).
import { ScrollView } from 'react-native';
import { MOEDAS, dinheiro } from '../lib/moeda';
import { t } from '../lib/i18n';
import { Chip, Sheet } from './ui';

export function EscolherMoeda({ visible, atual, cor, onClose, onEscolher }: { visible: boolean; atual: string; cor: string; onClose: () => void; onEscolher: (m: string) => void }) {
  return (
    <Sheet visible={visible} onClose={onClose} title={t('Moeda')}>
      <ScrollView contentContainerStyle={{ padding: 16, flexDirection: 'row', flexWrap: 'wrap', gap: 8 }}>
        {MOEDAS.map(x => <Chip key={x} cor={cor} on={x === atual} label={`${x} · ${dinheiro(1234.5, x)}`} onPress={() => { onEscolher(x); onClose(); }} />)}
      </ScrollView>
    </Sheet>
  );
}
